import { createSlice } from '@reduxjs/toolkit';

interface CU01702State {
    isVisibleCU01702: boolean;
}

const initialState: CU01702State = {
    isVisibleCU01702: false,
};

export const CU01702Slice = createSlice({
    name: 'CU01702Slice',
    initialState,
    reducers: {
        setVisibleCU01702: (state) => {
            state.isVisibleCU01702 = !state.isVisibleCU01702;
        },
        resetCU01702Slice: () => initialState,
    },
});

export const { setVisibleCU01702 } = CU01702Slice.actions;

export default CU01702Slice.reducer;
